module.exports = __webpack_public_path__ + "img/targeted-opportunities.e9ae2899.svg";